module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "signup"
  }, [_vm._c('form', {
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.subscribe($event)
      }
    }
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Your email",
      "aria-label": "Your email here",
      "name": "email",
      "autocomplete": "off",
      "required": "required"
    },
    domProps: {
      "value": _vm._s(_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.email || _vm.status !== ''
    }
  }, [_vm._v("Sign up")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-04f91bde!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/newsletter/SubscribeForm.vue
// module id = 614
// module chunks = 1